<template>
  <div class="rm-screen">
    <div v-if="isRange" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-calendar-today</v-icon>
      {{ $t("daily_report") }}
    </div>
    <div v-else-if="dayLoading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>

    <template v-else>
      <group-mobile-shift-chips v-model="selectedShift" :shifts="shifts"></group-mobile-shift-chips>

      <div class="rm-chip-row gm-chips" role="group" :aria-label="$t('view')">
        <button
          v-for="layout in layoutTabs"
          :key="layout.value"
          type="button"
          class="rm-chip"
          :class="{ 'rm-chip--active': selectedLayout === layout.value }"
          :aria-pressed="String(selectedLayout === layout.value)"
          @click="selectedLayout = layout.value"
        >
          {{ layout.text }}
        </button>
      </div>

      <div v-if="!rows.length" class="rm-empty">
        <template v-if="filters.search">{{ $t("report_mobile.no_results_for", { search: filters.search }) }}</template>
        <template v-else>
          <v-icon size="40" color="#8a817a">mdi-food-off</v-icon>
          {{ $t("no_orders_found") }}
        </template>
      </div>

      <template v-else>
        <div class="rm-stats rm-stats--pair">
          <div class="rm-stat rm-stat--inverse">
            <span class="rm-stat__label">{{ $t("report_desktop.workers") }}</span>
            <span class="rm-stat__value rm-num">{{ rows.length }}</span>
          </div>
          <div class="rm-stat">
            <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
            <span class="rm-stat__value rm-num">{{ mealTotal }}</span>
          </div>
        </div>
        <group-mobile-slip-list :slips="listSlips" :shift="Number(selectedShift)" :layout="selectedLayout"></group-mobile-slip-list>
      </template>
    </template>
  </div>
</template>

<script>
import CompanyReportTabCustomers from "@/components/company/reports/tabs/CompanyReportTabCustomers.vue";
import GroupMobileShiftChips from "@/components/report/mobile/screens/group/GroupMobileShiftChips.vue";
import GroupMobileSlipList from "@/components/report/mobile/screens/group/GroupMobileSlipList.vue";
import hasCompanyGroupOrdererRows from "../../hasCompanyGroupOrdererRows";

/**
 * Mobilni "Naručioci" firme tipa "grupa": jedna smena (oznake smena na vrhu), radnici sa obrocima po grupama jela i
 * napomenom; prikaz je količine i nazivi / nazivi / količine. Radi samo za jedan dan. Firme i period su u
 * zaglavlju, pretraga u lupi. Nasleđuje učitavanje, štampu i Excel iz starog taba.
 */
export default {
  name: "CompanyMobileGroupOrderers",
  extends: CompanyReportTabCustomers,
  mixins: [hasCompanyGroupOrdererRows],
  components: { GroupMobileShiftChips, GroupMobileSlipList },
  computed: {
    layoutTabs() {
      // četvrti izbor starog prikaza ("Rezervne obroke") nikad nije imao prikaz, pa ga ovde nema
      return this.layouts.filter((layout) => layout.value < 3);
    },
    listSlips() {
      return this.rows.map((row) => ({
        key: row.key,
        name: row.fullname,
        initials: row.fullname
          .split(" ")
          .filter(Boolean)
          .map((part) => part.charAt(0))
          .slice(0, 2)
          .join(""),
        note: row.note,
        categories: this.mealCategories
          .map((category) => ({ name: this.dayCategoryLabels[category], meals: row.cells[category] || [] }))
          .filter((category) => category.meals.length),
      }));
    },
  },
};
</script>
